<template>
  <component :is="convertedComponent" :key="htmlContentKey" class="inline" />
</template>

<script>
import { RouterLink } from 'vue-router';
import { mapState } from 'vuex';
import { convertHtmlToVueComponent } from '@/utils/html-to-vue';

/** Stable, cheap fingerprint so <component :is> remounts when CMS HTML changes (keys unchanged). */
function djb2Hash(str) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return hash >>> 0;
}

export default {
  name: 'HtmlToVue',
  props: {
    html: {
      type: String,
      required: true,
    },
  },
  components: { RouterLink },
  computed: {
    ...mapState('profile', [
      'id',
      'name',
      'organization',
      'email',
      'country',
      'groupName',
      'hashId',
    ]),
    htmlContentKey() {
      return `${this.html.length}:${djb2Hash(this.html)}`;
    },
    convertedComponent() {
      return convertHtmlToVueComponent(
        this.html,
        {
          id: this.id,
          name: this.name,
          email: this.email,
          organization: this.organization,
          country: this.country,
          groupName: this.groupName,
          hashId: this.hashId,
        },
        this.$route.path,
      );
    },
  },
};
</script>

<style></style>
